module.exports = __webpack_public_path__ + "img/8@2x.a149c5b6.png";